const topicFavoriteButton = document.querySelector('body.asgaros-forum-topic .favorite-button');

if (topicFavoriteButton) {
    const topicTitle = document.querySelector('body.asgaros-forum-topic .main-title-topic');

    // wrap the title in a div
    const titleWrapper = document.createElement('div');
    titleWrapper.classList.add('main-title-wrapper');
    topicTitle.parentNode.insertBefore(titleWrapper, topicTitle);
    titleWrapper.appendChild(topicTitle);

    // add the button to the title wrapper
    titleWrapper.appendChild(topicFavoriteButton);
}

const commentForm = document.getElementById('commentform');

if (commentForm) {
    commentForm.removeAttribute('novalidate');
}

import "./requestFeatureForm";
import "./requestFeatureThumbs";
import "./videos";
import "./download-preview";
import "./forumCodeHighlighting";
import "./freischaltcode";
import "./wikiSearch";
import "./searchBar";